import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { NotificationsNone } from "@material-ui/icons";
import { styledNotificationLinkCss } from "src/components/atoms/NotificationIndicator/styles";

export const StyledNotificationsIcon = styled(NotificationsNone, {
  shouldForwardProp: (prop) => prop !== "isActive",
})<{
  isActive: boolean;
}>`
  padding-bottom: 0;
  padding-top: 0;
  font-size: 24px;
  color: ${({ theme: { colors }, isActive }) =>
    isActive && colors.primaryColor ? colors.primaryColor : "#C0C6D0"};
`;

export const positionRelative = css`
  position: relative;
`;

export const StyledNotificationIndicator = styled("span", {
  shouldForwardProp: (prop) => prop !== "notificationCount",
})<{ notificationCount: number }>`
  ${({ theme, notificationCount }) =>
    styledNotificationLinkCss(notificationCount, theme.colors)}
  position: absolute;
  top: -8px;
  right: -8px;
  cursor: pointer;
`;

export const settingsIconContainerCss = css``;

export const bellLoaderCss = css`
  position: absolute;
  top: -8px;
  right: -8px;
  height: unset;
`;

export const NotificationsListItem = styled.li`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const NotificationsIconContainer = styled.button`
  position: relative;
  border: none;
  background-color: transparent;
  padding: 0 6px;
`;

export const NotificationsCollapseContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "visible",
})<{ visible: boolean }>`
  position: fixed;
  top: 3.6rem;
  right: 0;
  left: auto;

  width: 100vw;

  display: ${({ visible }) => (visible ? "flex" : "none")};
  flex-direction: column;
  box-shadow: rgb(231 232 236) 0px 2px 3px;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  z-index: 1000;

  translate: 0.3s ease-in;

  max-height: calc(100vh - 3.8rem);

  @media only screen and (min-width: 813px) {
    position: absolute;
    top: 100%;
    right: 0;
    width: auto;
    min-width: 27rem;

    max-height: calc(100vh - 4.5rem);
  }
`;
